import React from "react";
import ComparisonTable from "./ComparisonTable";
import type { IComparisonInfo } from "../declarations/types";
import type { IReadVerbPayload } from "../declarations/IReadVerbPayload";

interface IComparisonContainerProps {
    payload: IReadVerbPayload;
    useComparison: (payload: IReadVerbPayload) => { data: IComparisonInfo[] | undefined };
}

/**
 * Thin wrapper that runs a comparison-info hook against a payload and renders a ComparisonTable.
 * Replaces several near-identical per-entity containers (CustomerContainer, SalesOrderHeaderContainer,
 * SalesOrderHeaderChargeContainer, VatNumContainer) that all did the same thing with different hooks.
 *
 * `useComparison` must be a stable reference (e.g. an imported hook function), not redefined per render,
 * to honour the rules of hooks.
 */
export default function ComparisonContainer({
    payload,
    useComparison,
}: Readonly<IComparisonContainerProps>) {
    const { data } = useComparison(payload);
    return <ComparisonTable data={data} />;
}
